import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_ENDPOINT } from "src/constants/endpoints";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { restaurantSegment } from "src/utils/restaurantUrl";

export default function FinixOnboardingRefresh() {
  const { storeCorrelationId } = useParams();
  const navigate = useNavigate();
  const { axBe } = useAxiosInterceptor();
  const [message, setMessage] = useState("Preparing a new payment account setup link...");

  useEffect(() => {
    const refreshLink = async () => {
      if (!storeCorrelationId) {
        setMessage("Missing restaurant information.");
        return;
      }
      try {
        const response = await axBe.post(
          `${API_ENDPOINT}finix/merchant-onboarding/refresh`,
          { storeCorrelationId }
        );
        const onboardingUrl = response.data?.onboardingUrl;
        if (onboardingUrl) {
          window.location.href = onboardingUrl;
          return;
        }
        navigate(
          `/restaurants/${restaurantSegment(storeCorrelationId)}/restaurant-setting?tab=paymentAccount`,
          { replace: true }
        );
      } catch (error) {
        setMessage("Unable to refresh the setup link. Please return to settings and try again.");
      }
    };
    refreshLink();
  }, [axBe, navigate, storeCorrelationId]);

  return (
    <div className="flex h-[70vh] items-center justify-center">
      <div className="rounded-2xl border border-[#e5e7eb] bg-white px-8 py-6 text-center shadow-sm">
        <h1 className="text-xl font-semibold text-[#111827]">Payment Account</h1>
        <p className="mt-2 text-sm text-[#6b7280]">{message}</p>
      </div>
    </div>
  );
}
